module.exports = __webpack_public_path__ + "img/eln.0b356108.svg";